<template>
  <div>
    <!-- 下方内容 -->
    <div class="main1">
      <ul class="list yahei mb10">
        <div class="pub_content" style="*height:124px" v-for="item in docListdata" :key="item.code">
          <ul class="list yahei mb10">
            <li>
              <a
                target="_blank"
                :title="item.title"
                style="float:left"
                :href="'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?chnid='+item.chnid+'&leafid='+item.leafid+'&docid='+item.code.substring(4,item.code.length)+'&uid='+item.uid+'&version=YDYL'"
              >
                <img
                  src="../../assets/imgs/icon10.png"
                  style="margin-bottom:3px;"
                  class="mr10"
                  width="12"
                  height="16"
                />
                <span>{{ item.title | titleellipsis}}</span>
              </a>
              <span class="date de-date">
                [
                <span>{{item.deliveddate.substring(0,10)}}</span> ]
              </span>
              <ul class="extra clearfix clear">
                <li>
                  <strong class="mr5">⊙作者:</strong>
                  {{item.author}}
                </li>
                <li>
                  <strong class="mr5">⊙来源:</strong>
                  {{item.source}}
                </li>
              </ul>

              <ul class="extra clearfix abstract" style="clear:both;">
                <li>{{ item.summary | summaryellipsis}}</li>
              </ul>

              <div class="mt10">
                <span style="color:#393;float:left">⊙关键词：{{item.keywords}}</span>
              </div>
            </li>
          </ul>
        </div>
      </ul>

      <!-- 分页 -->
      <div style="width:650px;float:right" align="right">
        <el-pagination
          class="pagingsite"
          style="text-align:right;margin-right:1%;padding-bottom:30px;margin-top:30px;"
          background
          prev-text="上一页"
          next-text="下一页"
          layout="prev, pager, next,total,jumper"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          :total="total"
        ></el-pagination>
      </div>
      <div style="clear:both"></div>
    </div>
  </div>
</template>

<script>
import { api } from "@/require/api";
export default {
  name: "channel2",
  data() {
    return {
      uid: "", //url参数
      uid4: "", //4位长度的uid
      attr: "",
      subuid: "", //栏目id

      englishName: "", //国家基本信息
      channels: [],

      docListdata: [], //右侧docs
      currentPage: 1,
      pageSize: 5,
      total: 0
    };
  },
  filters: {
    //文章标题截取
    titleellipsis(value) {
      if (!value) return "";
      if (value.length > 40) {
        return value.slice(0, 40) + "...";
      }
      return value;
    },
    //文章简介截取
    summaryellipsis(value) {
      if (!value) return "";
      if (value.length > 100) {
        return value.slice(0, 100) + "...";
      }
      return value;
    }
  },
  created() {
    this.uid = this.$route.query.uid;
    this.uid4 = this.uid.toString().substring(0, 4);
    this.subuid = this.$route.query.subuid; //栏目id
    this.attr = this.$route.query.attr;

    this.setcurrentpageto1();
    this.loadcountrymodel();
    this.loaddocs();
  },
  methods: {
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},

    setcurrentpageto1() {
      // 初始化当前页
      this.currentPage = 1;
    },
    //国别基本信息
    async loadcountrymodel() {
      if (this.uid4.indexOf("8013"!== -1) && this.attr == undefined) {
        this.attr = "阿富汗";

        const { englishName, channels } = await api.get(
          "/documentController/getCountryInfo",
          {
            countryName: this.attr
          }
        );
        if (englishName != null) {
          this.channels = channels;
        }
      }
    },
    //获取文章列表
    async loaddocs() {
      const { code, data } = await api.get(
        "/documentController/getPageChannelDocumentsByUId",
        {
          uid: this.subuid,
          attr: this.attr,
          curPage: this.currentPage,
          pageSize: this.pageSize
        }
      );
      if (code === 0) {
        if (data !== null) {
          this.total = data.totlalCount;
          this.docListdata = data.data;
        }else{
          this.total = 0;
          this.docListdata = [];
        }
      }
    },
    // 分页-当前页
    handleCurrentChange(currentPageVal) {
      this.currentPage = currentPageVal;
      this.loaddocs();
    }
  },

  watch: {
    $route: function() {
      this.uid = this.$route.query.uid;
      this.uid4 = this.uid.toString().substring(0, 4);
      this.subuid = this.$route.query.subuid; //栏目id
      this.attr = this.$route.query.attr;

      this.setcurrentpageto1();
      this.loadcountrymodel();
      this.loaddocs();
    }
  }
};
</script>
<style lang='less'>
</style>